import { RedirectionTypesEnum } from 'common/enums/ButtonActionEnum'
import React from 'react'
import { SuccessButtonTextUi } from 'src/publisher/entities/button-new/components/success-button-text-ui'
import {
  CommonPublisherButtonEntityOrSubEntity,
  CommonPublisherButtonEntityOrSubEntityProps,
} from 'src/publisher/shared/components/button/common-publisher-button-entity-or-sub-entity'
import { useThemeColor } from 'src/publisher/shared/hooks/use-theme-color'
import { SendFormActionButtonEntityInterface } from 'src/shared/entities/button/send-form.action-button.schema'

export interface CommonPublisherSendFormButtonEntityOrSubEntityProps
  extends CommonPublisherButtonEntityOrSubEntityProps {
  entityOrSubEntity: SendFormActionButtonEntityInterface
  isSuccess: boolean
}

export const CommonPublisherSendFormButtonEntityOrSubEntity = ({
  isSuccess,
  entityOrSubEntity,
  ...rest
}: CommonPublisherSendFormButtonEntityOrSubEntityProps) => {
  const {
    text: { paragraphTextColor },
  } = useThemeColor()
  return (
    <CommonPublisherButtonEntityOrSubEntity
      entityOrSubEntity={entityOrSubEntity}
      {...rest}
      endElement={
        isSuccess &&
        entityOrSubEntity.redirectionType === RedirectionTypesEnum.none && (
          <SuccessButtonTextUi
            alignSelf={entityOrSubEntity.alignSelf}
            mobileAlignSelf={entityOrSubEntity.mobileAlignSelf}
            textColor={
              entityOrSubEntity.optInSuccessTextColor || paragraphTextColor
            }
          >
            {entityOrSubEntity.optInSuccessText}
          </SuccessButtonTextUi>
        )
      }
    />
  )
}
